import { render, staticRenderFns } from "./AiSuggestionStartupCostParser.vue?vue&type=template&id=f6f4eb12"
import script from "./AiSuggestionStartupCostParser.vue?vue&type=script&lang=js"
export * from "./AiSuggestionStartupCostParser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports